import { Injectable, NgZone} from '@angular/core';
import { CustomService } from './custom.service';
import * as $ from "jquery";


@Injectable({
  providedIn: 'root'
})
export class LayoutService {

  public device_info="";
  public animationDiv_Arrays = [
    ".main",
    "#pdf_container",
    ".alertmsg",
    "#wPaint",    
    ".sidenav",
    ".fk_sthome_fullscreen",
    ".leftmenucontainer",
    ".workingbookleftmenucontainer",
    ".index_fullscreen",
    ".leftmenuicon_inloggningpdf",
    ".pdflistimg",
    ".pdf_home_content",
    ".printpdftext",
    ".pdf_fullscreen",
    ".startpage_fullscreen",
    ".fullscreen",
    ".leftmenuiconstorybook",
    "#spara",
    "#assigningtext1",
    "#assigningtext2",
    ".assign_leftmenu_table",
    ".assign_leftmenu_submit",
    ".assign_leftmenu_tick",
    ".wb_popup_fullscreen",
    "#text1",
    "#text2"

  ];

    constructor(public customService : CustomService)
    {
      this.device_info=customService.getDeviceInfo();
    }

    initLayout()
    {
        let thisme=this;
        setTimeout(function () {
          thisme.menuactive();
        },1500);
      this.edgeInit();
    }

        menuactive() {

        var a = $("#menu_ReadBook_img").width();
        var b = $("#menu_ReadBook_img").height();

        var width_sub = 3;
        var height_add = 20;
          if (a > 0 && b > 0) {
            $("#menu_ReadBook_active").width((a - width_sub) + "px");
            $("#menu_ReadBook_active").height((b + height_add) + "px");
            var a = $("#menu_WorkBook_img").width();
            var b = $("#menu_WorkBook_img").height();
            $("#menu_WorkBook_active").width((a - width_sub) + "px");
            $("#menu_WorkBook_active").height((b + height_add) + "px");
          }
        }


        openNav() {
         this.toggleMenuLayout(true);
        }

        closeNav() {
          this.toggleMenuLayout(false);
        }



      toggleMenuLayout(flag)
      {
        let thisme:any=this;

        let animationDivs = this.animationDiv_Arrays.toString();
        $(animationDivs).addClass("animationtime");

          setTimeout(function () {
            if(flag) //open menu
            {
              thisme.customService.removeClass("body","nav_closed");
            }
            else //close menu
            {
              thisme.customService.addClass("body","nav_closed");
            }
          }, 100);


        setTimeout(function () {
         $(animationDivs).removeClass("animationtime");
          if(window['drawingtoolService'])
          {
            window['drawingtoolService'].drawing_canvas_resizing();
          }
        }, 1000);
      }



  //dropdown in reading book for touch sreen

    testto()
    {
      if (this.device_info === "IE" || this.device_info === "Edge")
      {
        var open_close = $(".FK_exercisedropdown-content").css("display");
        $(".FK_exercisedropdown-content").css("display", "block");
      }
    }


edgeInit()
{

  if (this.device_info === "IE" || this.device_info === "Edge") {
    
    $('html').click(function (e) {
      if (e.target.id !== "FK_rbex_label" && $(e.target).parents('#FK_rbex_label').length === 0) {

        $(".FK_exercisedropdown-content").css("display", "none");
      }

      if (e.target.id !== "FK_rbstory_label" && $(e.target).parents('#FK_rbstory_label').length === 0) {

        $(".FK_rbstorydropdown-content").css("display", "none");
      }

      if (e.target.id !== "menu_Tillaren" && e.target.class !== "dropdown1_Tillaren" && $(e.target).parents('#menu_Tillaren').length === 0) {
        $(".dropdown-content_Tillaren,.dropdown-content1_Tillaren").css("display", "none");

      }

      if (e.target.id !== "menu_Tincan" && $(e.target).parents('#menu_Tincan').length === 0) {
        $(".tincan1").css("display", "inline-block");
        $(".tincan2").css("display", "none");
        $(".dropdown-content_tincan").css("display", "none");
        $(".dropdown-content1_tincan").hide();
        $(".dropdown-content2_tincan").hide();
        $(".dropdown-content3_tincan").hide();
      }
      else {

      }
    });
  }
}

}
